// extracted by mini-css-extract-plugin
module.exports = {"load-shedding-B":"B_load-shedding-B__feM7a"};